// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = () => ({
  map: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    top: 0,
    bottom: 0,
    width: '100%',
    flex: 1,
  },
  mapContainer: {
    position: 'relative',
    flex: 1,
    minHeight: 0,
  },
});

export default styles;
